module.exports = __webpack_public_path__ + "img/Katarina_home_08.ffdcf02d.jpg";